<template>
  <div class="container" style="padding-top: 5rem">
    <div class="account-box">
      <!-- LOGIN FORM -->
      <div class="account-wrapper">
        <h3 class="account-title">
          Class Booking System<br />Main Admin Login
        </h3>
        <hr />
        <form @submit.prevent="login">
          <p class="text-danger text-center" v-if="errorMessage">
            {{ errorMessage }}
          </p>
          <div class="form-group">
            <label>ID</label>
            <input
              class="form-control"
              type="text"
              v-model="username"
              maxlength="50"
              required
            />
          </div>
          <div class="form-group">
            <label>Password</label>
            <input
              class="form-control"
              type="password"
              v-model="password"
              maxlength="50"
              required
              autocomplete="off"
            />
          </div>
          <div class="form-group text-center">
            <button class="btn btn-primary account-btn" type="submit">
              Sign In
            </button>
          </div>
          <div class="form-group text-center mb-1">
            <router-link :to="{ name: 'mainAdminForgotPassword' }">
              Forgot password?
            </router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import API from "../../http-common.js";

export default {
  data() {
    return {
      errorMessage: "",
      username: "",
      password: "",
    };
  },
  methods: {
    login() {
      this.errorMessage = "";
      this.$store.state.isLoading = true;
      API.mainAdmin
        .login({ UserName: this.username, Password: this.password })
        .then((response) => {
          this.$store.state.isLoading = false;
          let success = response.data.success;
          if (success) {
            localStorage.setItem(
              "cbstoken",
              JSON.stringify(response.data.data)
            );
            this.$router.replace({ name: "schoolList" });
          } else {
            this.errorMessage = response.data.message;
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
          this.errorMessage = error;
        });
    },
  },
};
</script>

<style scoped>
.container {
  background: url("/static/bg-image.jpg") no-repeat center fixed;
  background-size: cover;
  -webkit-background-size: cover;
  max-width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/MainAdmin/Login.vue